/**
 * Shared constants for regional map logic.
 * Author: bb
 */

import { normalizeBundeslandName } from "./mapHelpers";
import type { MapLayerId } from "./mapHelpers";

export const LAYER_PRIORITY: Record<MapLayerId, number> = {
  federalStates: 0,
  administrativeDistricts: 1,
  districts: 2,
  postalCodes: 3,
};

/**
 * Label keys for detail layer buttons used in the RegionalFilterSection UI.
 */
export const DETAIL_LAYER_LABELS: Record<MapLayerId, string> = {
  federalStates: "categories.mapLayerStatesShort",
  administrativeDistricts: "categories.mapLayerAdministrativeShort",
  districts: "categories.mapLayerDistrictsShort",
  postalCodes: "categories.mapLayerPostalCodesShort",
};

/** Small zoom multipliers to keep deeper layers comfortably visible. */
export const getZoomBoost = (
  layer: MapLayerId,
  stateName: string | null
): number => {
  if (!stateName) return 1;
  const normalized = normalizeBundeslandName(stateName);
  if (!normalized) return 1;
  if (layer === "administrativeDistricts") {
    return 1.5;
  }
  if (layer === "districts") {
    return 1.5;
  }
  if (layer === "postalCodes") {
    return 1.5;
  }
  return 1.5;
};
